import * as FC from "@fluentui/react-components";

export const buildFilter = (searchable, filter) => {
    return searchable
        .map((i) => {
            return `${i} CONTAINS '${filter}'`;
        })
        .join(" OR ");
};

export const idString = (recordId) => {
    if (typeof recordId === "string") {
        return recordId;
    }
    if (typeof recordId === "object" && recordId.tb) {
        return `${recordId.tb}:${recordId.id}`;
    }
    if (!recordId) {
        return recordId;
    }
    if (recordId.rid) {
        return recordId.rid;
    }
    return recordId.toString();
};

export const idRecord = (recordId) => {
    if (!recordId) {
        return recordId;
    }
    if (typeof recordId === "string") {
        return recordId;
    }
    if (typeof recordId === "object" && recordId.tb) {
        return `${recordId.tb}:${recordId.id}`;
    }
    if (recordId?.rid) {
        return recordId.rid;
    }
    return recordId;
};

export const filterToCondition = (searchable, filter, vars) => {
    filter = filter?.trim();
    if (!filter) {
        return null;
    }

    let condition = searchable
        .map((column) => `${column} CONTAINS \$filter`)
        .join(" OR ");
    vars["filter"] = filter;

    return condition;
};

export const cvtTaskRecheckType = (typ) => {
    if (typ == "全量复核") return "full";
    if (typ == "二次复核") return "partial";

    const table = { full: "全量复核", partial: "二次复核" };

    return table[typ];
};

export const cvtPriority = (priority) => {
    const table = ["高", "中", "低"];

    if (table.indexOf(priority) >= 0) {
        return table.indexOf(priority) + 1;
    }

    return table[priority - 1];
};

export const enumTaskPriority = [
    {
        value: 1,
        text: "高",
        color: "#f00",
    },
    {
        value: 2,
        text: "中",
        color: "#000",
    },
    {
        value: 3,
        text: "低",
        color: "#999",
    },
];

export const optionsTaskPriority = [
    { value: "", text: "全部" },
    ...enumTaskPriority,
];

export const mapTaskPriority = Object.fromEntries(
    enumTaskPriority.map((it) => [it.value, it]),
);

export const TaskPriorityBadge = ({ priority, style, ...props }) => {
    let p = mapTaskPriority[priority];
    let color = p?.color || "#999";
    style = { color, ...style };

    return (
        <span style={style} {...props}>
            {p?.text}
        </span>
    );
};

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const TaskPriorityDropdown = (props) => {
    return (
        <FC.Dropdown {...props}>
            {optionsTaskPriority.map((option) => (
                <FC.Option key={option.value} value={option.value}>
                    {option.text}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};

//-------------------
export const enumTaskTypeRecheck = [
    {
        value: "full",
        text: "全量复核",
    },
    {
        value: "partial",
        text: "部分复核",
    },
];
export const mapTaskTypeRecheck = Object.fromEntries(
    enumTaskTypeRecheck.map((it) => [it.value, it]),
);

//------------------------

export const TaskStatus = {
    create: "创建",
    created: "创建",
    check: "巡检",
    checking: "巡检",
    annotation: "后台",
    ai: "后台",
    recheck: "复核",
    rechecking: "复核",
    done: "完成",
    completed: "完成",
    ready_to_release: "待发布",
    released: "已发布",
    deleted: "删除",
    uploading: "上传中",
    processing: "处理中",
    error: "错误",
};

export const cvtTaskStatus = (status) => {
    for (const key in TaskStatus) {
        if (TaskStatus[key] == status) {
            return TaskStatus[key];
        }
    }

    return TaskStatus[status];
};

export const enumTaskStatus = [
    {
        value: "created",
        text: "创建",
        color: "#D13438",
    },
    {
        value: "checking",
        text: "巡检",
        color: "#0078D4",
    },
    {
        value: "annotation",
        text: "标注",
        color: "#8B5CF6",
    },
    {
        value: "partial_annotation",
        text: "部分标注",
        color: "#B197FC",
    },
    {
        value: "ai",
        text: "AI核查",
        color: "#ccc",
    },
    {
        value: "rechecking",
        text: "人工复核",
        color: "#FF7723",
    },
    {
        value: "completed",
        text: "完成",
        color: "#107C10",
    },
    {
        value: "partial_completed",
        text: "部分完成",
        color: "#59A14F",
    },
    {
        value: "ready_to_release",
        text: "待发布",
        color: "#13C2C2",
    },
    {
        value: "released",
        text: "已发布",
        color: "#595959",
    },
    {
        value: "deleted",
        text: "删除",
        color: "#999",
    },
    {
        value: "uploading",
        text: "上传中", 
        color: "#FFA500",
    },
    {
        value: "processing",
        text: "处理中",
        color: "#1E90FF",
    },
    {
        value: "error",
        text: "错误",
        color: "#DC3545",
    },
];

export const optionsTaskStatus = [
    {
        value: "",
        text: "全部",
    },
    ...enumTaskStatus,
];

export const mapTaskStatus = Object.fromEntries(
    enumTaskStatus.map((it) => [it.value, it]),
);

export const TaskStatusBadge = ({ status, style, className, ...props }) => {
    let s = mapTaskStatus[status];
    const color = s?.color || "#999";
    style = { borderColor: color, color, ...style };
    className ||= "border py-1 px-2 rounded-lg inline-block font-xs scale-75";
    return (
        <div className={className} style={style} {...props}>
            {s?.text || "-"}
        </div>
    );
};

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const TaskStatusDropdown = (props) => {
    return (
        <FC.Dropdown {...props}>
            {optionsTaskStatus.map((it) => (
                <FC.Option key={it.value} value={it.value}>
                    {/*<TaskStatusBadge status={it.value} />*/}
                    {it.text}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};

//-----------------
export const LeafPart = {
    front: "前缘",
    belly: "腹板",
    back: "后缘",
    none: "未知",
};

export const cvtLeafPart = (part) => {
    for (const key in LeafPart) {
        if (LeafPart[key] == part) {
            return LeafPart[key];
        }
    }

    return LeafPart[part];
};

export const enumPart = [
    {
        value: "front",
        text: "前缘",
    },
    {
        value: "belly",
        text: "腹板",
    },
    {
        value: "back",
        text: "后缘",
    },
    {
        value: "none",
        text: "未知",
    },
];
export const mapPart = Object.fromEntries(enumPart.map((it) => [it.value, it]));
export const optionsPart = [{ value: "", text: "全部" }, ...enumPart];

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const PartDropdown = (props) => {
    return (
        <FC.Dropdown {...props}>
            {optionsPart.map((option) => (
                <FC.Option key={option.value} value={option.value}>
                    {option.text}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};

//-----------------
export const enumLabelBy = [
    {
        value: "human",
        text: "人工",
    },
    {
        value: "ai",
        text: "AI",
    },
];

export const mapLabelBy = Object.fromEntries(
    enumLabelBy.map((it) => [it.value, it]),
);
export const optionsLabelBy = [{ value: "", text: "全部" }, ...enumLabelBy];
//-----------------
export const RawDataStatus = {
    create: "创建",
    uploading: "上传中",
    uploaded: "上传完",
    preprocessing: "预处理",
    done: "预处理完成",
    error: "错误",
    deleted: "删除",
};

export const cvtRawDataStatus = (status) => {
    for (const key in RawDataStatus) {
        if (RawDataStatus[key] == status) {
            return RawDataStatus[key];
        }
    }

    return RawDataStatus[status];
};

export const parseDateAsPath = (date) => {
    date = (date && new Date(date)) || new Date(Date.now());
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return `${year}/${month}/${day}`;
};

export const shortId = (id) => {
    if (id?.id) {
        id = id.id;
    }
    if (!id) {
        return null;
    }
    let parts = id.split(":");
    id = parts[parts.length - 1];
    id = id.substring(0, 6);
    return id;
};

export const formatFloat = (f, decimal = 2) => {
    if (!f) {
        return "0";
    }
    f = parseFloat(f);
    if (!f) {
        return "0";
    }
    return f.toFixed(decimal);
};

// Wind turbine blade inspection path names mapping
export const InspectionPathName = {
    "迎风前缘": "迎风前缘",
    "迎风后缘": "迎风后缘", 
    "背风前缘": "背风前缘",
    "背风后缘": "背风后缘",
    "右侧向外": "右侧向外",
    "左侧向内": "左侧向内",
    "左侧向外": "左侧向外", 
    "右侧向内": "右侧向内",
    "未知路径": "未知路径"
};

export const cvtInspectionPathName = (pathName) => {
    return InspectionPathName[pathName] || pathName || "未知路径";
};

// export const getCurrentField
